const isAdmin = group => {
  if (!group) {
    return false
  }
  const { access } = group
  return access === 'F' || access === 'B' || access === 'A'
}

export default isAdmin



// WEBPACK FOOTER //
// ./src/utils/isAdmin.js